import { JSX } from 'react';
import { genericAtom } from '../jotai';
export interface DropdownState {
    isOpen?: boolean;
    content?: JSX.Element | null;
    footer?: JSX.Element | null;
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
    width?: number | 'auto' | `${number}%` | null;
    denyHide?: boolean;
}

const globalDropdownStateDefault: DropdownState = {
    isOpen: false,
    content: null,
    footer: null,
};

export const globalDropdownState = genericAtom<DropdownState | null>(
    globalDropdownStateDefault,
);

